(ns shared.core.amelia-light.components.json-viewer
  (:require [shared.core.amelia-light.components.icon :as icon]
            [shared.core.reactive :as re]
            [shared.core.style :as style]))

(def slot-width 14)

(def font-family "ui-monospace, SFMono-Regular, Menlo, monospace")

(defn token-color [token-type]
  (let [dark? (= @(re/subscribe [:alc/theme-]) :dark-mode)]
    (get {:key (if dark? "#C77DBB" "#871094")
          :string (if dark? "#6AAB73" "#067D17")
          :number (if dark? "#2AACB8" "#1750EB")
          :literal (if dark? "#CF8E6D" "#0033B3")
          :punctuation (style/alc-color "Text/primary")
          :hint (style/alc-color "Text/secondary")}
         token-type)))

(defn token [token-type text]
  [:span {:style {:color (token-color token-type)
                  :font-family font-family}}
   text])

(defn line [& contents]
  (into [:div {:style {:display :flex
                       :align-items :center
                       :white-space :pre}}]
        contents))

(defn json-node [{:keys [depth collapsed?]}]
  (let [expanded?* (re/ratom (or (zero? depth) (not collapsed?)))]
    (fn [{:keys [k v depth last? collapsed?]}]
      (let [comma (when-not last?
                    [token :punctuation ","])
            key-token (when k
                        [:<>
                         [token :key (js/JSON.stringify k)]
                         [token :punctuation ": "]])
            empty-slot [:div {:style {:flex "0 0 auto"
                                      :width slot-width}}]]
        (if-not (or (array? v) (object? v))
          [line
           empty-slot
           key-token
           [token (cond
                    (string? v) :string
                    (number? v) :number
                    :else :literal)
            (js/JSON.stringify v)]
           comma]
          (let [array? (array? v)
                entries (if array?
                          (map vector (repeat nil) v)
                          (js/Object.entries v))
                n (count entries)
                [open close] (if array? ["[" "]"] ["{" "}"])
                toggle #(swap! expanded?* not)]
            (if (zero? n)
              [line empty-slot key-token [token :punctuation (str open close)] comma]
              [:div
               [line
                [:div {:style {:flex "0 0 auto"
                               :width slot-width
                               :display :flex
                               :align-items :center
                               :justify-content :center
                               :cursor :pointer
                               :transform (when @expanded?* "rotate(90deg)")
                               :transition "transform 0.15s"}
                       :on-click toggle}
                 [icon/up-icon {:icon-type :ChevronRightIcon
                                :class-name "h-3 w-3"
                                :style {:color (style/alc-color "Icons/secondary")
                                        :display :flex}}]]
                [:span {:style {:cursor :pointer}
                        :on-click toggle}
                 key-token]
                [token :punctuation open]
                (when-not @expanded?*
                  [:<>
                   [:span {:style {:cursor :pointer}
                           :on-click toggle}
                    [token :hint "…"]]
                   [token :punctuation close]
                   comma
                   [:span {:style {:font-style :italic
                                   :padding-left 8}}
                    [token :hint (str n (if array? " item" " key") (when (not= n 1) "s"))]]])]
               (when @expanded?*
                 [:<>
                  (into [:div {:style {:border-left (str "1px solid " (style/alc-color "Border/divider"))
                                       :margin-left (/ slot-width 2)
                                       :padding-left (dec (/ slot-width 2))}}]
                        (map-indexed (fn [idx [child-k child-v]]
                                       [json-node {:k child-k
                                                   :v child-v
                                                   :depth (inc depth)
                                                   :last? (= idx (dec n))
                                                   :collapsed? collapsed?}])
                                     entries))
                  [line empty-slot [token :punctuation close] comma]])])))))))

(defn json-viewer
  "Color-coded, collapsible view of `json`, a JSON string. `collapsed?` starts every
   nested object and array closed; text that is not JSON is shown as-is."
  [{:keys [json collapsed? style]}]
  (let [parsed (try
                 (js/JSON.parse json)
                 (catch :default _
                   ::invalid))]
    [:div {:style (merge {:background-color (style/alc-color "Background/secondary")
                          :border (str "1px solid " (style/alc-color "Border/divider_secondary"))
                          :border-radius 8
                          :color (style/alc-color "Text/primary")
                          :font-size 12
                          :line-height 1.5
                          :overflow :auto
                          :padding 12}
                         style)}
     (if (= parsed ::invalid)
       [:div {:style {:font-family font-family
                      :white-space :pre}}
        json]
       [:div {:style {:min-width :max-content}}
        [json-node {:v parsed
                    :depth 0
                    :last? true
                    :collapsed? collapsed?}]])]))
